import { isMobile, isTablet } from "react-device-detect";

export const useGetDeviceType = () => {
  if (isMobile) {
    return "mobile";
  }

  if (isTablet) {
    return "tablet";
  }

  return "desktop";
};
